import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RecaptchaModule } from 'ng-recaptcha'
import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { seFeIconHidden, SeFeIconModule, seFeIconVisible } from 'se-fe-icon'
import { SeFeLinkModule } from 'se-fe-link'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import {
  SeHouseholdSetupFeatureAlreadyHaveAccountModule
} from '@se-po/se-household-setup-feature-already-have-account'

import { CreatePasswordComponent } from './create-password/create-password.component'
import { PasswordFormCreateService } from './create-password/password-form-create.service'

@NgModule({
  declarations: [CreatePasswordComponent],
  exports: [CreatePasswordComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    SeHouseholdSetupFeatureAlreadyHaveAccountModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeIconModule.include([seFeIconVisible, seFeIconHidden]),
    SeFeLinkModule,
    SeFeSpinnerModule,
  ],
  providers: [PasswordFormCreateService]
})
export class SeHouseholdSetupFeatureCreatePasswordModule { }
